import { MarketingConfig } from "types";

export const marketingConfig: MarketingConfig = {
  mainNav: [

    // {
    //   title: "Free Tools",
    //   href: "/tools",
    //   items: [
    //     {
    //       title: "Screenshot Comparison",
    //       href: "/tools/screenshot-comparison",
    //     },
    //     {
    //       title: "Website Full Page Screenshot",
    //       href: "/tools/full-page-website-screenshot",
    //     },
    //     {
    //       title: "Open Graph Screenshot",
    //       href: "/tools/open-graph-screenshot",
    //     },
    //   ],
    // },
    {
      title: "Documentation",
      href: "/docs",
    },
    // {
    //   title: "Blog",
    //   href: "/blog",
    // },
    {
      title: "Pricing",
      href: "/pricing",
    },
  ],
};
